import { GenericService } from '@/services/api/generic.service';
import { Customer } from '@/models';

export class CustomersService extends GenericService<Customer> {

  constructor() {
    super('v1/customers');
  }
}
